exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./~/sass-loader!./src/scss/styles.scss
// module id = 180
// module chunks = 2